export default __webpack_public_path__ + "static/media/btc.481e5be4.svg";